export default __webpack_public_path__ + "static/international-yards-mobile-c201a765d54247289a46445870b54d48.svg";